// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .modal-content {
    background-color: #e0dac0;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 400px;
    text-align: center;
    font-family: 'Roboto', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 10000;
  }
  
  .modal-content h2 {
    color: #144040;
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .modal-content form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .modal-content input[type="email"],
  .modal-content input[type="password"] {
    width: 100%;
    max-width: 350px;
    padding: 12px 15px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 14px;
    text-align: left;
    color: #333;
    background-color: #fff;
    box-sizing: border-box;
    transition: border-color 0.3s ease;
  }
  
  .modal-content input[type="email"]:focus,
  .modal-content input[type="password"]:focus {
    outline: none;
    border-color: #144040;
    box-shadow: 0 0 0 2px rgba(20, 64, 64, 0.1);
  }
  
  .modal-content button[type="submit"],
  .google-login-button {
    width: 100%;
    max-width: 350px;
    padding: 12px 20px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    border: none;
    margin-bottom: 10px;
  }
  
  .modal-content button[type="submit"] {
    background-color: #144040;
    color: #fff;
  }
  
  .modal-content button[type="submit"]:hover {
    background-color: #0f3030;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(20, 64, 64, 0.3);
  }
  
  .google-login-button {
    background-color: white;
    color: #333;
    border: 1px solid #ddd;
    margin-top: 5px;
  }
  
  .google-login-button:hover {
    background-color: #f8f9fa;
    border-color: #adb5bd;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .google-logo {
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
  
  .modal-content p {
    font-size: 14px;
    color: #144040;
    cursor: pointer;
    margin-top: 20px;
    padding: 8px;
    border-radius: 5px;
    transition: all 0.3s ease;
  }
  
  .modal-content p:hover {
    text-decoration: underline;
    background-color: rgba(20, 64, 64, 0.1);
  }


.sign-in-prompt {
    background-color: #e0dac0;
    padding: 40px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    text-align: center;
    max-width: 400px;
    margin: 100px auto;
    font-family: 'Roboto', sans-serif;
  }
  
  .sign-in-prompt h2 {
    color: #144040;
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .sign-in-prompt p {
    font-size: 16px;
    margin-bottom: 30px;
    color: #333;
  }
  
  .sign-in-prompt button {
    background-color: #144040;
    color: #fff;
    border: none;
    padding: 10px;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    margin: 10px;
    transition: background-color 0.3s;
  }
  
  .sign-in-prompt button:hover {
    background-color: #0f3030;
  }
  
  .sign-in-prompt button:focus {
    outline: none;
  }
  
  
  .close-button {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 24px;
    color: #144040;
    cursor: pointer;
    padding: 5px;
    line-height: 1;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }
  
  .close-button:hover {
    color: #fff;
    background-color: #144040;
    transform: rotate(90deg);
  }
  
  .error-message {
    color: #dc3545;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 15px;
    font-size: 14px;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./src/login/LoginModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;;IAEE,aAAa;IACb,qBAAqB;IACrB,2CAA2C;EAC7C;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,uCAAuC;EACzC;;;AAGF;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;EACnC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n  }\n  \n  .modal-content {\n    background-color: #e0dac0;\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    width: 100%;\n    max-width: 400px;\n    text-align: center;\n    font-family: 'Roboto', sans-serif;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    z-index: 10000;\n  }\n  \n  .modal-content h2 {\n    color: #144040;\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .modal-content form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .modal-content input[type=\"email\"],\n  .modal-content input[type=\"password\"] {\n    width: 100%;\n    max-width: 350px;\n    padding: 12px 15px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 14px;\n    text-align: left;\n    color: #333;\n    background-color: #fff;\n    box-sizing: border-box;\n    transition: border-color 0.3s ease;\n  }\n  \n  .modal-content input[type=\"email\"]:focus,\n  .modal-content input[type=\"password\"]:focus {\n    outline: none;\n    border-color: #144040;\n    box-shadow: 0 0 0 2px rgba(20, 64, 64, 0.1);\n  }\n  \n  .modal-content button[type=\"submit\"],\n  .google-login-button {\n    width: 100%;\n    max-width: 350px;\n    padding: 12px 20px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.3s ease;\n    border: none;\n    margin-bottom: 10px;\n  }\n  \n  .modal-content button[type=\"submit\"] {\n    background-color: #144040;\n    color: #fff;\n  }\n  \n  .modal-content button[type=\"submit\"]:hover {\n    background-color: #0f3030;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(20, 64, 64, 0.3);\n  }\n  \n  .google-login-button {\n    background-color: white;\n    color: #333;\n    border: 1px solid #ddd;\n    margin-top: 5px;\n  }\n  \n  .google-login-button:hover {\n    background-color: #f8f9fa;\n    border-color: #adb5bd;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .google-logo {\n    margin-right: 10px;\n    width: 20px;\n    height: 20px;\n  }\n  \n  .modal-content p {\n    font-size: 14px;\n    color: #144040;\n    cursor: pointer;\n    margin-top: 20px;\n    padding: 8px;\n    border-radius: 5px;\n    transition: all 0.3s ease;\n  }\n  \n  .modal-content p:hover {\n    text-decoration: underline;\n    background-color: rgba(20, 64, 64, 0.1);\n  }\n\n\n.sign-in-prompt {\n    background-color: #e0dac0;\n    padding: 40px;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    text-align: center;\n    max-width: 400px;\n    margin: 100px auto;\n    font-family: 'Roboto', sans-serif;\n  }\n  \n  .sign-in-prompt h2 {\n    color: #144040;\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .sign-in-prompt p {\n    font-size: 16px;\n    margin-bottom: 30px;\n    color: #333;\n  }\n  \n  .sign-in-prompt button {\n    background-color: #144040;\n    color: #fff;\n    border: none;\n    padding: 10px;\n    border-radius: 5px;\n    font-size: 16px;\n    cursor: pointer;\n    margin: 10px;\n    transition: background-color 0.3s;\n  }\n  \n  .sign-in-prompt button:hover {\n    background-color: #0f3030;\n  }\n  \n  .sign-in-prompt button:focus {\n    outline: none;\n  }\n  \n  \n  .close-button {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    color: #144040;\n    cursor: pointer;\n    padding: 5px;\n    line-height: 1;\n    border-radius: 50%;\n    width: 35px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n  }\n  \n  .close-button:hover {\n    color: #fff;\n    background-color: #144040;\n    transform: rotate(90deg);\n  }\n  \n  .error-message {\n    color: #dc3545;\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    border-radius: 5px;\n    padding: 10px;\n    margin-bottom: 15px;\n    font-size: 14px;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
